module.exports = __webpack_public_path__ + "static/assets/be075df9239fb217fba63a2314d27a6a.png";